import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdHomePageReloadFromAshGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | Observable<boolean | UrlTree> {
    const sourceASH = localStorage.getItem('source')?.toLocaleLowerCase() === 'ash';
    const sourceSNOW = localStorage.getItem('source')?.toLocaleLowerCase() === 'snow';

    if (sourceASH || sourceSNOW) {
      window.parent.postMessage('OnePortal-HOME', '*');
      return false;
    }

    return true;
  }
}
